import { ISocietiesModel } from '../../interfaces/models/societies.interfaces'

export function getIsSamf(society?: ISocietiesModel): boolean | undefined {
  if (!society || !society?.societyTypeDisplayName) {
    return undefined
  }
  if (
    [
      'homeowners_association',
      'non_profit_association',
      'economic_association',
    ].includes(society?.societyTypeDisplayName || '')
  ) {
    return true
  }
  return false
}
export function getSocietyActiveTrialStatus(society?: ISocietiesModel): {
  active: boolean
  daysLeft: number | undefined
} {
  if (!society) {
    return { active: false, daysLeft: undefined }
  }
  if (
    society.accountType === 'premium' ||
    (society.societyTypeDisplayName &&
      ![
        'housing_cooperative',
        'homeowners_association',
        'economic_association',
      ].includes(society.societyTypeDisplayName)) ||
    !society.trialPeriodEndDate
  ) {
    return { active: false, daysLeft: undefined }
  }

  const timeDiff =
    new Date(society.trialPeriodEndDate).getTime() - new Date().getTime()

  const daysLeft = Math.ceil(timeDiff / (1000 * 3600 * 24))

  return { active: daysLeft > 0, daysLeft }
}
